import { Icon } from '@/components/Icon';
import type { WizardState } from './wizardState';

/**
 * Шаг 3 — только "Выдать": списывать при создании нечего (баланс нового
 * клиента ещё нулевой), поэтому без кнопки-переключателя выдать/списать, как
 * в BalancePanel/BalanceActionForm на карточке клиента — сумма и комментарий
 * сразу видны, поле пустое = ничего не выдавать (см. buildCreatePayload() в
 * wizardState.ts). Реальная операция уйдёт на бэк вместе с созданием клиента
 * (см. useSubmitWizard.ts). Лицензионный тариф — только информационный блок,
 * без ссылки на управление (аккаунта ещё нет).
 */
export function StepBalance({
  state,
  onChange,
}: {
  state: WizardState;
  onChange: (state: WizardState) => void;
}) {
  if (state.tariffType === 'license') {
    return (
      <div className="tariff-card" style={{ maxWidth: 420 }}>
        <div className="tariff-card__head">
          <div className="tariff-card__icon">
            <Icon name="fileText" size={18} />
          </div>
          <div>
            <div className="tariff-card__name">Лицензии</div>
            <div className="tariff-card__sub">Тариф</div>
          </div>
        </div>
        <div className="tariff-card__empty">
          <Icon name="alertCircle" size={15} />
          <span>Управление лицензиями осуществляется на стороне Maintest 5i.</span>
        </div>
      </div>
    );
  }

  const update = (patch: Partial<{ amount: string; comment: string }>) => {
    onChange({ ...state, balanceAction: { ...state.balanceAction, ...patch } });
  };

  return (
    <div className="tariff-card" style={{ maxWidth: 420 }}>
      <div className="tariff-card__head">
        <div className="tariff-card__icon">
          <Icon name="psi" size={18} />
        </div>
        <div>
          <div className="tariff-card__name">Условные единицы</div>
          <div className="tariff-card__sub">Выдать баланс при создании — необязательно</div>
        </div>
      </div>

      <div className="balance-form">
        <label className="balance-form__field">
          <span>Сумма, у.е.</span>
          <input
            type="number"
            min={1}
            value={state.balanceAction.amount}
            onChange={(e) => update({ amount: e.target.value })}
          />
        </label>
        <label className="balance-form__field">
          <span>Комментарий к операции</span>
          <textarea
            rows={2}
            value={state.balanceAction.comment}
            onChange={(e) => update({ comment: e.target.value })}
            placeholder="Необязательно"
          />
        </label>
      </div>
    </div>
  );
}
